



































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { VbSnackbarService } from 'bag-of-holding-library';
import Priority from '@/domain/activity/entity/priority.entity';
import Assessment from '@/domain/assessment/entity/assessment';
import AssessmentSimulationSimple from '@/domain/assessment/entity/assessment-simulation-list.entity';
import AssessmentService from '@/domain/assessment/service/assessment.service';
import Loading from '@/shared/loading/loading.component.vue';
import AssessmentItemComponent from './assessment-item.component.vue';
import NewAssessmentModalComponent from '../components/new-assessment-modal.component.vue';
import AssessmentComponent from './assessment.component.vue';

@Component({
  components: {
    AssessmentItemComponent,
    NewAssessmentModalComponent,
    Loading,
    AssessmentComponent,
  },
})
class AssessmentSimulationTabComponent extends Vue {
  @Prop({
    type: String,
    required: true,
  }) employeeId!: string;

  @Prop({
    type: Array,
    required: true,
  }) priorityItems!: Priority[];

  @Prop({
    type: Boolean,
    required: true,
  }) isUserLoggedIn!: boolean;


  simulation: Assessment | null = null;

  simulations: AssessmentSimulationSimple[] = [];

  simulationSearch: string = '';

  openNewSimulationModal: boolean = false;

  loadingSimulations: boolean = false;

  get filteredSimulations() {
    if (!this.simulationSearch) return this.simulations;
    const search = this.simulationSearch.toLowerCase();
    return this.simulations
      .filter(sim => (sim.assignmentName && sim.assignmentName.toLowerCase().includes(search))
      || (sim.levelName && sim.levelName.toLowerCase().includes(search)));
  }

  created() {
    this.getSimulations();
  }

  getSimulations() {
    this.loadingSimulations = true;
    AssessmentService.getSimulationsByEmployeeId(this.employeeId)
      .then(response => this.simulations = response)
      .finally(() => this.loadingSimulations = false);
  }

  handleSimulationCreated(simulation: Assessment) {
    this.simulation = simulation;
    this.openNewSimulationModal = false;
  }

  handleViewSimulation(simulationItem: AssessmentSimulationSimple) {
    simulationItem.loadingViewSimulation = true;
    AssessmentService.getByAssessmentId(
      simulationItem.id,
    ).then((response) => {
      this.simulation = response;
    })
      .catch((error) => {
        VbSnackbarService.handleHttpError(error);
      })
      .finally(() => simulationItem.loadingViewSimulation = false);
  }

  handleBackToList() {
    this.simulation = null;
    this.getSimulations();
  }
}

export default AssessmentSimulationTabComponent;
